// export const ROOT_API = process.env.REACT_APP_API_ROOT_URL;

let API_DOMAIN = "";

if (window.location.hostname === "localhost") {
  API_DOMAIN = "http://localhost:8000/";
} else {
  API_DOMAIN = "https://api.nemastruje.com/";
}

export const ROOT_API = API_DOMAIN;

export const headers = {
  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  "Content-Type": "application/json",
  // lang: "hr",
};
